<template>
  <div>
    <div ref="print_customer" class="hidden">
      <div
        class="row"
        v-if="reprint || order.has_changed || order.status === 'denied'"
      >
        <div class="reprint-cont" v-if="reprint">
          <span class="reprint">چاپ مجدد</span>
        </div>
        <div class="reprint-cont" v-if="order.has_changed">
          <span class="reprint">ویرایش شده</span>
        </div>
        <div class="reprint-cont" v-if="order.status === 'denied'">
          <span class="reprint">لغو شده</span>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div v-if="currentProvider" class="provider-info">
            <img
              v-if="currentProvider.logo"
              :src="currentProvider.logo.url"
              :alt="currentProvider.persian_name"
            />
            <span>{{ currentProvider.persian_name }}</span>
          </div>
          <div>
            شماره فیش:
            <span class="receipt-number">{{ receiptNumber }}</span>
          </div>
        </div>
        <li>
          <span class="value">{{ order.created_at }}</span>
        </li>
        <li v-if="order.user && order.user.name">
          <span class="title">مشترک گرامی: </span>
          <span class="value">{{ order.user.name }}</span>
        </li>
        <li v-if="order.user && order.type !== 'indoor'">
          <span class="title">شماره موبایل: </span>
          <span class="value">{{ order.user.phone }}</span>
        </li>
        <li>
          <span class="title">سریال سفارش: </span>
          <span class="value">{{ order.serial }}</span>
        </li>
        <li v-if="order.payment && order.payment.gateway_reference">
          <span class="title">شماره پیگیری پرداخت: </span>
          <span class="value">{{ order.payment.gateway_reference }}</span>
        </li>
        <li
          v-if="
            (order.userDetails && order.userDetails.destination) || order.table
          "
        >
          <span class="title">مکان: </span>
          <span class="tablenum" v-if="order.type === 'indoor'"
            >میز {{ getDestination() }}</span
          >
          <span class="value" v-else>{{ getDestination() }}</span>
        </li>
        <li v-if="order.userDetails && order.userDetails.description">
          <span class="title">توضیحات:</span>
          <span class="value">{{ order.userDetails.description }}</span>
        </li>
        <table>
          <thead>
            <tr>
              <th>نام محصول</th>
              <th>فی</th>
              <th>تعداد</th>
              <th>قیمت</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in order.items" :key="item.id">
              <td>
                {{ item.title }}
                <template v-if="item.discount">
                  (%{{ item.discount }})
                </template>
              </td>
              <td>
                {{ calcProductPrice(item, true).toString().numberFormat() }}
              </td>
              <td>
                {{ item.quantity }}
              </td>
              <td>
                {{
                  (calcProductPrice(item, true) * item.quantity)
                    .toString()
                    .numberFormat()
                }}
              </td>
            </tr>
          </tbody>
        </table>
        <li
          v-if="order.providerDetails && order.providerDetails.processingTime"
          class="row"
        >
          <span class="title">زمان تحویل: </span>
          <span class="value">{{ getProcessingTime(order) }}</span>
        </li>
        <li class="row">
          <span class="title">نوع تحویل: </span>
          <span class="value" v-if="order.type === 'indoor'">{{
            "داخل سالن"
          }}</span>
          <span class="value" v-if="order.type === 'outdoor'">{{
            "ارسالی"
          }}</span>
          <span class="value" v-if="order.type === 'takeaway'">{{
            "تحویل در محل"
          }}</span>
        </li>
        <li class="row">
          <span class="title">نحوه پرداخت: </span>
          <span class="value" v-if="order.paymentType === 'offline'"
            >پرداخت در محل</span
          >
          <span class="value" v-else-if="order.paymentType === 'online'"
            >آنلاین</span
          >
        </li>
        <li class="row">
          <span class="line"></span>
        </li>
        <li class="row">
          <span class="title">جمع کل: </span>
          <span class="value"
            >{{
              calcProductsPriceSum(order.items, true).toString().numberFormat()
            }}
            ریال</span
          >
        </li>
        <li class="row" v-if="+order.delivery_fee > 0">
          <span class="title">هزینه پیک: </span>
          <span class="value"
            >{{ order.delivery_fee.toString().numberFormat() }} ریال</span
          >
        </li>
        <li v-if="+order.discount > 0" class="row">
          <span class="title">تخفیف: </span>
          <span class="value"
            >{{ order.discount.toString().numberFormat() }} ریال</span
          >
        </li>
        <li class="row">
          <span class="title">قابل پرداخت: </span>
          <span class="value"
            >{{ order.price.toString().numberFormat() }} ریال</span
          >
        </li>
        <li v-if="+order.vat > 0" class="row" style="margin-top: 10px">
          <span style="font-size: 0.9rem"
            >تمامی قیمت های بالا با مالیات {{ TAX_LABEL }} محاسبه شده است.</span
          >
        </li>
        <div style="page-break-before: always"></div>
        <div style="position: absolute; bottom: 0"></div>
      </div>
    </div>
    <div ref="print_provider" class="hidden">
      <div
        class="row"
        v-if="reprint || order.has_changed || order.status === 'denied'"
      >
        <div class="reprint-cont" v-if="reprint">
          <span class="reprint">چاپ مجدد</span>
        </div>
        <div class="reprint-cont" v-if="order.has_changed">
          <span class="reprint">ویرایش شده</span>
        </div>
        <div class="reprint-cont" v-if="order.status === 'denied'">
          <span class="reprint">لغو شده</span>
        </div>
      </div>
      <div class="container">
        <div>
          شماره فیش:
          <span class="receipt-number">{{ receiptNumber }}</span>
        </div>
        <li>
          <span class="value">{{ order.created_at }}</span>
        </li>
        <li v-if="order.user && order.type !== 'indoor'">
          <span class="title">شماره مشتری: </span>
          <span class="value">{{ order.user.phone }}</span>
        </li>
        <li v-if="order.type === 'indoor'">
          <span class="title">مکان: </span>
          <span class="tablenum">میز {{ getDestination() }}</span>
        </li>
        <li v-if="order.userDetails && order.userDetails.description">
          <span class="title">توضیحات: </span>
          <span class="value">{{ order.userDetails.description }}</span>
        </li>
        <table>
          <thead>
            <tr>
              <th>نام محصول</th>
              <th>تعداد</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in order.items" :key="item.id">
              <td style="font-size: 1.4rem">
                {{ item.title }}
                <template v-if="item.discount">
                  (%{{ item.discount }})
                </template>
              </td>
              <td style="width: 40px; font-size: 1.4rem">
                {{ item.quantity }}
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>
        <li>
          <span class="title-d">نوع سفارش: </span>
          <span class="value-d">{{ getOrderType() }}</span>
        </li>
        <li
          v-if="order.providerDetails && order.providerDetails.processingTime"
        >
          <span class="title">زمان تحویل: </span>
          <span class="value">{{ getProcessingTime(order) }}</span>
        </li>
      </div>
      <div style="page-break-before: always"></div>
      <div style="position: absolute; bottom: 0"></div>
    </div>
  </div>
</template>

<script>
import Printd from "printd";
import moment from "moment";
import { mapGetters } from "vuex";
import { TAX_FEE, TAX_LABEL } from "../../helpers/Constants";
import {
  convertToEnglishDigit,
  generateReceiptNumber,
} from "../../helpers/Functions";

export default {
  name: "WebPrintReceipt",
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  data() {
    return {
      receiptNumber: 0,
      reprint: false,
      TAX_LABEL,
    };
  },
  props: {
    order: {
      required: true,
      type: Object,
    },
    index: {
      requird: false,
      type: Number,
    },
  },
  methods: {
    getDestination() {
      if (this.order.type === "indoor") {
        return this.order.table?.title || this.order.userDetails.destination;
      }

      return convertToEnglishDigit(this.order.userDetails.destination);
    },
    getOrderType() {
      if (this.order.type === "indoor") {
        return "داخل سالن";
      } else if (this.order.type === "outdoor") {
        return "ارسالی";
      } else {
        return "تحویل در محل";
      }
    },
    getProcessingTime() {
      if (this.order.providerDetails) {
        const time = moment(this.order.providerDetails.processingTime)?.format(
          "HH:mm"
        );
        return time;
      }

      return null;
    },
    customerPrint() {
      return new Promise((resolve) => {
        generateReceiptNumber(this.order)
          .then(({ num, reprint }) => {
            this.receiptNumber = num;
            this.reprint = reprint;
          })
          .then(() => {
            const d = new Printd();

            d.print(this.$refs.print_customer, [
              `
                    html, body {
                        height: 100px;
                        width: 100%;
                    }

                    * {
                        padding: 0;
                        margin: 0;
                        font-family: 'tahoma';
                        font-weight: 500;
                        direction: rtl;
                        text-align: right;
                        font-size: 11px;
                        font-weight: 600;
                    }

                    .container {
                        position:relative;
                        overflow:hidden;
                        background: #ffe !important;
                        margin: 0.25cm;
                    }

                    .row {
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-between;
                      margin: 12px 0;
                    }

                    .line {
                      width: 100%;
                      display: block;
                      height: 1px;
                      border: 0;
                      border-top: 1px solid #232323;
                      padding: 0;
                    }

                    .receipt-number {
                      font-size: 1.5rem;
                    }

                    .reprint-cont {
                      max-width: 150px;
                      text-align: center;
                      border-radius: 5px;
                      border: 1px solid;
                      padding: 10px 20px;
                    }

                    .reprint {
                      font-size: 1.5rem;
                    }

                    ul, li {
                        list-style-type: none;
                    }

                    li {
                        margin: 15px 0;
                    }

                    title {
                      font-size: 0.85rem;
                      color: #000000;
                    }

                    li .value {
                      font-size: 1.1rem;
                      color: #000000;
                    }

                    .tablenum {
                      font-size: 1.7rem;
                    }

                    .table-col {
                      font-size: 1.2rem;
                    }

                    .final-price {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    table {
                        width: 100%;
                        max-width: 100%;
                        margin-bottom: 1rem;
                        border: 1px solid #000000;
                        border-collapse: collapse;
                    }

                    table th {
                        font-weight: 600;
                    }

                    table caption {
                        margin-bottom: 1rem;
                        font-weight: 600;
                        text-align: center;
                    }

                    table th, table td {
                        padding: 0.75rem;
                        vertical-align: top;
                        border-top: 1px solid #000000;
                        text-align: center;
                    }

                    table thead th {
                        vertical-align: bottom;
                        border-bottom: 2px solid #000000;
                    }

                    table tfoot td {
                        border-top: 2px solid #000000;
                    }

                    table tbody + tbody {
                        border-top: 2px solid #000000;
                    }

                    table th, table td {
                        border: 1px solid #000000;
                    }

                    table thead th, table thead td {
                        border-bottom-width: 2px;
                    }
                    
                    .provider-info {
                        display: flex;
                        align-items: center;     
                    }

                    .provider-info img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-left: 10px;
                    }
                `,
            ]);
          })
          .finally(() => {
            resolve(this.receiptNumber);
          });
      });
    },
    providerPrint() {
      return new Promise((resolve) => {
        generateReceiptNumber(this.order)
          .then(({ num, reprint }) => {
            this.receiptNumber = num;
            this.reprint = reprint;
            resolve(num);
          })
          .finally(() => {
            const d = new Printd();

            d.print(this.$refs.print_provider, [
              `
                    html, body {
                        height: 100px;
                        width: 100%;
                    }

                    * {
                        padding: 0;
                        margin: 0;
                        font-family: 'tahoma';
                        font-weight: 500;
                        direction: rtl;
                        text-align: right;
                        font-size: 11px;
                        font-weight: 600;
                    }

                    .container {
                        position:relative;
                        overflow:hidden;
                        background: #ffe !important;
                        margin: 0.5cm;
                    }

                    .row {
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-between;
                      margin: 12px 0;
                    }

                    .line {
                      width: 100%;
                      display: block;
                      height: 1px;
                      border: 0;
                      border-top: 1px solid #232323;
                      padding: 0;
                    }

                    .receipt-number {
                      font-size: 1.5rem;
                    }

                    .reprint-cont {
                      max-width: 150px;
                      text-align: center;
                      border-radius: 5px;
                      border: 1px solid;
                      padding: 10px 20px;
                    }

                    .reprint {
                      font-size: 1.5rem;
                    }

                    ul, li {
                        list-style-type: none;
                    }

                    li {
                        margin: 15px 0;
                    }

                    title {
                      font-size: 0.85rem;
                      color: #000000;
                    }

                    li .value {
                      font-size: 1.1rem;
                      color: #000000;
                    }

                    .tablenum {
                      font-size: 1.7rem;
                    }

                    .table-col {
                      font-size: 1.2rem;
                    }

                    .final-price {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    table {
                        width: 100%;
                        max-width: 100%;
                        margin-bottom: 1rem;
                        border: 1px solid #000000;
                        border-collapse: collapse;
                    }

                    table th {
                        font-weight: 600;
                    }

                    table caption {
                        margin-bottom: 1rem;
                        font-weight: 600;
                        text-align: center;
                    }

                    table th, table td {
                        padding: 0.75rem;
                        vertical-align: top;
                        border-top: 1px solid #000000;
                        text-align: center;
                    }

                    table thead th {
                        vertical-align: bottom;
                        border-bottom: 2px solid #000000;
                    }

                    table tfoot td {
                        border-top: 2px solid #000000;
                    }

                    table tbody + tbody {
                        border-top: 2px solid #000000;
                    }

                    table th, table td {
                        border: 1px solid #000000;
                    }

                    table thead th, table thead td {
                        border-bottom-width: 2px;
                    }
                    
                    .provider-info {
                        display: flex;
                        align-items: center;     
                    }

                    .provider-info img {
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        margin-left: 10px;
                    }
                `,
            ]).finally(() => {
              resolve(this.receiptNumber);
            });
          });
      });
    },
    calcProductPrice(product, withTax = false) {
      let tax = 0;

      if (withTax && this.order.vat > 0) {
        tax = product.tax || TAX_FEE;
      }

      const discount = product.discount || 0; // Discount of item
      const priceWithDiscount =
        product.price - product.price * (discount / 100); // Calculated price with discount
      const finalPrice = priceWithDiscount + priceWithDiscount * tax; // Calculated price with tax

      return finalPrice;
    },
    calcProductsPriceSum(items, withTax = false) {
      if (items) {
        let price = 0;
        items.forEach((element) => {
          price += this.calcProductPrice(element, withTax) * element.quantity;
        });
        return price;
      }

      return 0;
    },
  },
};
</script>